/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/cookie
import Cookies from 'js-cookie';
/**
 * Returns 'atlassian-token' aka xsrf required to secure some operation.
 *
 *
 * Security note: it is important to read from cookies - the same source backend will use to validate the operation
 * The attempt to read it from meta-data ('atlassian-token') resulted in Sev2 HOT-108450
 *
 * The cookie is a part of XSRF technology itself and is exempt from "safe cookies"/FedRAMP requirements.
 * The technology is based on one's ability to read the cookie and this is one it shall be preserved.
 *
 * There is ongoing work to migrate from legacy experiences that rely on this sort of protection
 * Until the work is not done, it shall stay untouched
 * See:
 *  - https://jplat.jira.atlassian.cloud/browse/ISSUEHELP-1198
 */
const getXSRFToken = (): string | undefined => Cookies.get('atlassian.xsrf.token');

export default getXSRFToken;
